import { Banner } from "@hireart/component-library";
import PropTypes from "prop-types";
import {
  isOvernightShift,
  formatNextDayInfo,
  ShiftShape,
} from "common/utils/timesheet";

/**
 * Core component that works with new ShiftData type
 * Uses only functions from the lib
 * Handles incomplete data gracefully
 */
export const CrossDayNotification = ({ shift, shiftDate }) => {
  // Handle incomplete shift data gracefully
  if (!shift.startTime || !shift.endTime) {
    return null;
  }

  // Check if this shift crosses into the next day using lib function
  if (!isOvernightShift(shift)) {
    return null;
  }

  // Get formatted next day info using lib function
  const nextDayInfo = formatNextDayInfo(shiftDate);

  return (
    <Banner variant="warning" className="mt-4">
      <div className="body-2 mb-1 font-semibold">Overnight shift</div>
      <div className="body-2">
        This shift ends on {nextDayInfo.dayName}, {nextDayInfo.month}{" "}
        {nextDayInfo.day}
      </div>
    </Banner>
  );
};

CrossDayNotification.propTypes = {
  shift: ShiftShape.isRequired,
  shiftDate: PropTypes.instanceOf(Date).isRequired,
};
